module.exports = __webpack_public_path__ + "img/pro-ctsw.a424892d.png";